var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import styles from "./BirdsnestProductCard.module.scss";
import { removeFromWishlist, addToWishlist, convertToSwymProduct, checkIfWishlisted, toNumericId } from "../../utils/useSwymInit";
import { isProductInWishlist, isVariantInWishlist, WISHLIST_UPDATED_EVENT } from "../../utils/wishlistCache";
import getProductInfoQuery, { preloadProductInfo } from "../../utils/shopify/queries";
import { LoadingSkeleton } from "./BirdsnestProductGrid";
import { addToCart } from "../../utils/shopify/cart";
import { getColorFromMetaobjectMap } from "../../utils/helpers";
import { trackSelectItem, trackAddToCart, } from "../../utils/elevar";
import { getInstoreModeFromStorage, syncInstoreModeFromUrl, useFittingRoomPopupOpener, } from "../fitting-room";
import { BackInStockPopup } from "../back-in-stock";
export function BirdsnestProductCard({ product, layout, isModelView = true, smallCard = false, ratingAverage, ratingCount, ratingAverageHeart, isPreloved = false, ratingCountHeart, isHeaderSearch = false, trackingListId, trackingPosition }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    console.log(product);
    const openFittingRoomPopup = useFittingRoomPopupOpener();
    //console.log("Rendering BirdsnestProductCard for product:", product);
    const [selectedColorIndex, setSelectedColorIndex] = useState(0);
    const [selectedSize, setSelectedSize] = useState(null);
    const [isWishlisted, setIsWishlisted] = useState(false);
    const [hasHovered, setHasHovered] = useState(false);
    const [addingToCart, setAddingToCart] = useState(false);
    const [cartError, setCartError] = useState(null);
    const [cartSuccess, setCartSuccess] = useState(false);
    const { id, price, image, rating, size = [], promoMessage: promoMessageFromFH, customAttributes, variants, seeInOutfit, metafields, tags } = product;
    const [activeVariants, setActiveVariants] = useState(variants || []);
    const isQuickViewEnabled = ((_a = window.liquidCustom) === null || _a === void 0 ? void 0 : _a.showQuickViewProductCard) === 'quick_buy';
    const [title, setTitle] = useState(product.title);
    const [brand, setBrand] = useState(product.brand);
    const [videoMain, setVideoMain] = useState("");
    const [imgMain, setImgMain] = useState("");
    const [imgSecond, setImgSecond] = useState("");
    /** Normalise image URL for main display: keep only v= from query, then add width=700 */
    const normalizeImageUrlForMain = (url) => {
        if (!url || typeof url !== "string")
            return url;
        const qIndex = url.indexOf("?");
        const base = qIndex >= 0 ? url.slice(0, qIndex) : url;
        if (qIndex < 0)
            return base + "?width=700";
        const vMatch = url.slice(qIndex + 1).match(/v=([^&?]*)/);
        const v = vMatch ? vMatch[1] : null;
        return v != null ? base + "?v=" + v + "&width=700" : base + "?width=700";
    };
    const setImgMainNormalized = (value) => setImgMain(normalizeImageUrlForMain(value || ""));
    const setImgSecondNormalized = (value) => setImgSecond(normalizeImageUrlForMain(value || ""));
    const [priceRegular, setPriceRegular] = useState(price.regular);
    const [priceSale, setPriceSale] = useState(price.sale);
    const [sizeOptions, setSizeOptions] = useState([]);
    const [handle, setHandle] = useState(product === null || product === void 0 ? void 0 : product.handle);
    const [productId, setProductId] = useState(id);
    const [images, setImages] = useState({ model: '', imgProduct: '', imgSecond: '' });
    const [loadingSwatch, setLoadingSwatch] = useState(false);
    const [promoMessage, setPromoMessage] = useState(promoMessageFromFH);
    const [promoBgColor, setPromoBgColor] = useState(undefined);
    const [promoFontColor, setPromoFontColor] = useState(undefined);
    // Track selected size by label (title) in state so it survives color switches
    const [selectedSizeTitle, setSelectedSizeTitle] = useState(null);
    // Only auto-add after user has clicked a size or color (prevents single-size items adding on load)
    const userHasInteractedWithSelectionRef = useRef(false);
    // Fallback variant ID for products that appear without variants like quick search suggestions
    const defaultVariantIdRef = useRef(null);
    // Ref to the product card root element, used to scope queries to this card only
    const productCardRef = useRef(null);
    const [backInStockOption, setBackInStockOption] = useState(null);
    const extractPromoData = (shopifyProduct) => {
        var _a, _b;
        const mf = (_a = shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.metafields) === null || _a === void 0 ? void 0 : _a.find((m) => (m === null || m === void 0 ? void 0 : m.namespace) === 'custom' && (m === null || m === void 0 ? void 0 : m.key) === 'promotion');
        const fields = (_b = mf === null || mf === void 0 ? void 0 : mf.reference) === null || _b === void 0 ? void 0 : _b.fields;
        if (!fields)
            return {};
        const get = (key) => { var _a, _b; return (_b = (_a = fields.find((f) => f.key === key)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : undefined; };
        return {
            name: get('promo_name'),
            bgColor: get('background_colour'),
            fontColor: get('font_colour'),
        };
    };
    // Preload swatch product data + own product in background on mount, then resolve promo
    useEffect(() => {
        const ownId = String(id).replace(/^.*?(\d+)$/, "$1");
        const swatchInfo = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.swatch_info;
        const swatchIds = Array.isArray(swatchInfo) && swatchInfo.length >= 2
            ? swatchInfo.map((s) => String(s.product_id).replace(/^.*?(\d+)$/, "$1"))
            : [];
        preloadProductInfo([ownId, ...swatchIds]).then(() => {
            getProductInfoQuery(ownId).then(result => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                const { name: promoName, bgColor, fontColor } = extractPromoData((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.product);
                if (promoName !== undefined)
                    setPromoMessage(promoName);
                if (bgColor !== undefined)
                    setPromoBgColor(`#${bgColor}`);
                if (fontColor !== undefined)
                    setPromoFontColor(`#${fontColor}`);
                // Fall back to Shopify vendor when the feed didn't include a brand
                if (!product.brand) {
                    const vendor = (_c = (_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.vendor;
                    if (vendor)
                        setBrand(vendor);
                }
                // When the provider didn't supply variants (e.g. quick search suggestions), capture
                // the first variant ID from Shopify so the wishlist button has something to work with.
                if (!(variants === null || variants === void 0 ? void 0 : variants.length)) {
                    const firstEdge = (_g = (_f = (_e = (_d = result === null || result === void 0 ? void 0 : result.data) === null || _d === void 0 ? void 0 : _d.product) === null || _e === void 0 ? void 0 : _e.variants) === null || _f === void 0 ? void 0 : _f.edges) === null || _g === void 0 ? void 0 : _g[0];
                    const firstId = (_j = (_h = firstEdge === null || firstEdge === void 0 ? void 0 : firstEdge.node) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 ? void 0 : _j.split("/").pop();
                    if (firstId)
                        defaultVariantIdRef.current = firstId;
                }
            });
        });
    }, []);
    // Detect mobile device (especially iOS)
    const isMobileDevice = () => {
        if (typeof window === 'undefined')
            return false;
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    };
    const getRelatedVariantsData = (productIdOrHandle) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        try {
            // Support both numeric id and GID (e.g. gid://shopify/Product/123)
            const idForQuery = String(productIdOrHandle).replace(/^.*?(\d+)$/, "$1");
            const { data, errors } = (yield getProductInfoQuery(idForQuery)) || {
                data: null,
                errors: null,
            };
            if (data) {
                // console.log("Related variants data:", data?.product);
                setTitle((data === null || data === void 0 ? void 0 : data.product.title) || (product === null || product === void 0 ? void 0 : product.title));
                setBrand((data === null || data === void 0 ? void 0 : data.product.vendor) || (product === null || product === void 0 ? void 0 : product.brand));
                const imageUrl = typeof image === 'string' ? image : image === null || image === void 0 ? void 0 : image.url;
                setImgMainNormalized(((_a = data === null || data === void 0 ? void 0 : data.product.featuredImage) === null || _a === void 0 ? void 0 : _a.src) || imageUrl || "");
                // Shopify: priceV2 = current price (sale when discounted), compareAtPriceV2 = original price
                const currentAmount = parseFloat((_c = (_b = data === null || data === void 0 ? void 0 : data.product.selectedOrFirstAvailableVariant) === null || _b === void 0 ? void 0 : _b.priceV2) === null || _c === void 0 ? void 0 : _c.amount);
                const compareAtAmount = parseFloat((_e = (_d = data === null || data === void 0 ? void 0 : data.product.selectedOrFirstAvailableVariant) === null || _d === void 0 ? void 0 : _d.compareAtPriceV2) === null || _e === void 0 ? void 0 : _e.amount);
                // If variant price is -1 or invalid, use product price (e.g. search/feed sometimes sends -1)
                const isValidPrice = (n) => n != null && !Number.isNaN(n) && n >= 0;
                const variantRegular = isValidPrice(currentAmount) ? currentAmount : price.regular;
                const variantCompareAt = isValidPrice(compareAtAmount) ? compareAtAmount : undefined;
                const hasCompareAt = variantCompareAt != null;
                setPriceRegular(hasCompareAt ? variantCompareAt : variantRegular);
                setPriceSale(hasCompareAt ? (isValidPrice(currentAmount) ? currentAmount : ((_f = price.sale) !== null && _f !== void 0 ? _f : undefined)) : ((_g = price.sale) !== null && _g !== void 0 ? _g : undefined));
                // Don't auto-select size - user must select manually
                // setSelectedSize(
                //   data?.product.selectedOrFirstAvailableVariant?.id?.split("/").pop() ||
                //     null,
                // );
                setHandle((data === null || data === void 0 ? void 0 : data.product.handle) || product.handle);
                setProductId(((_j = (_h = data === null || data === void 0 ? void 0 : data.product) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 ? void 0 : _j.split("/").pop()) || product.id);
                //Product image: Always get image have Product_Front
                const productFrontImage = (_m = (_l = (_k = data === null || data === void 0 ? void 0 : data.product) === null || _k === void 0 ? void 0 : _k.media) === null || _l === void 0 ? void 0 : _l.edges) === null || _m === void 0 ? void 0 : _m.find((edge) => {
                    var _a, _b, _c, _d;
                    if (((_a = edge === null || edge === void 0 ? void 0 : edge.node) === null || _a === void 0 ? void 0 : _a.mediaContentType) !== "IMAGE")
                        return false;
                    const alt = ((_b = edge === null || edge === void 0 ? void 0 : edge.node) === null || _b === void 0 ? void 0 : _b.alt) || "";
                    const url = ((_d = (_c = edge === null || edge === void 0 ? void 0 : edge.node) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d.url) || "";
                    return alt.includes("Product_Front") || url.includes("Product_Front");
                });
                //Fallback to First image contain _Product_ if no Product_Front found. Currently skip
                //Model image: use featuredImage from product data
                const modelImage = data === null || data === void 0 ? void 0 : data.product.featuredImage;
                setImages({
                    model: (modelImage === null || modelImage === void 0 ? void 0 : modelImage.src) || "",
                    imgProduct: ((_p = (_o = productFrontImage === null || productFrontImage === void 0 ? void 0 : productFrontImage.node) === null || _o === void 0 ? void 0 : _o.image) === null || _p === void 0 ? void 0 : _p.url) || "",
                    imgSecond: ((_u = (_t = (_s = (_r = (_q = data === null || data === void 0 ? void 0 : data.product) === null || _q === void 0 ? void 0 : _q.images) === null || _r === void 0 ? void 0 : _r.edges) === null || _s === void 0 ? void 0 : _s[1]) === null || _t === void 0 ? void 0 : _t.node) === null || _u === void 0 ? void 0 : _u.src) || "",
                });
                const firstMedia = (_x = (_w = (_v = data === null || data === void 0 ? void 0 : data.product) === null || _v === void 0 ? void 0 : _v.media) === null || _w === void 0 ? void 0 : _w.edges) === null || _x === void 0 ? void 0 : _x[0];
                if (((_y = firstMedia === null || firstMedia === void 0 ? void 0 : firstMedia.node) === null || _y === void 0 ? void 0 : _y.mediaContentType) === "VIDEO") {
                    setVideoMain(((_1 = (_0 = (_z = firstMedia === null || firstMedia === void 0 ? void 0 : firstMedia.node) === null || _z === void 0 ? void 0 : _z.sources) === null || _0 === void 0 ? void 0 : _0[0]) === null || _1 === void 0 ? void 0 : _1.url) || "");
                }
                else {
                    setVideoMain("");
                }
                const fetchedVariants = (((_3 = (_2 = data === null || data === void 0 ? void 0 : data.product) === null || _2 === void 0 ? void 0 : _2.variants) === null || _3 === void 0 ? void 0 : _3.edges) || []).map((edge) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                    const regular = parseFloat((_b = (_a = edge.node) === null || _a === void 0 ? void 0 : _a.priceV2) === null || _b === void 0 ? void 0 : _b.amount);
                    const sale = parseFloat((_d = (_c = edge.node) === null || _c === void 0 ? void 0 : _c.compareAtPriceV2) === null || _d === void 0 ? void 0 : _d.amount);
                    const sizeOption = (_f = (_e = edge.node) === null || _e === void 0 ? void 0 : _e.selectedOptions) === null || _f === void 0 ? void 0 : _f.find((opt) => (opt === null || opt === void 0 ? void 0 : opt.name) === "Size" || (opt === null || opt === void 0 ? void 0 : opt.name) === "Title");
                    const sizeLabel = (_j = (_g = sizeOption === null || sizeOption === void 0 ? void 0 : sizeOption.value) !== null && _g !== void 0 ? _g : (_h = edge.node) === null || _h === void 0 ? void 0 : _h.title) !== null && _j !== void 0 ? _j : "";
                    return {
                        id: edge.node.id,
                        title: sizeLabel,
                        sku: ((_k = edge.node) === null || _k === void 0 ? void 0 : _k.sku) || "",
                        available: ((_l = edge.node) === null || _l === void 0 ? void 0 : _l.availableForSale) || false,
                        price: {
                            regular: isValidPrice(regular) ? regular : price.regular,
                            sale: isValidPrice(sale) ? sale : ((_m = price.sale) !== null && _m !== void 0 ? _m : undefined),
                        },
                        selectedOptions: (_o = edge.node) === null || _o === void 0 ? void 0 : _o.selectedOptions,
                    };
                });
                setActiveVariants(fetchedVariants);
                const newSizeOptions = (((_5 = (_4 = data === null || data === void 0 ? void 0 : data.product) === null || _4 === void 0 ? void 0 : _4.variants) === null || _5 === void 0 ? void 0 : _5.edges) || []).map((edge) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                    const regular = parseFloat((_b = (_a = edge.node) === null || _a === void 0 ? void 0 : _a.priceV2) === null || _b === void 0 ? void 0 : _b.amount);
                    const sale = parseFloat((_d = (_c = edge.node) === null || _c === void 0 ? void 0 : _c.compareAtPriceV2) === null || _d === void 0 ? void 0 : _d.amount);
                    const sizeOption = (_f = (_e = edge.node) === null || _e === void 0 ? void 0 : _e.selectedOptions) === null || _f === void 0 ? void 0 : _f.find((opt) => (opt === null || opt === void 0 ? void 0 : opt.name) === "Size" || (opt === null || opt === void 0 ? void 0 : opt.name) === "Title");
                    const sizeLabel = (_j = (_g = sizeOption === null || sizeOption === void 0 ? void 0 : sizeOption.value) !== null && _g !== void 0 ? _g : (_h = edge.node) === null || _h === void 0 ? void 0 : _h.title) !== null && _j !== void 0 ? _j : "";
                    return {
                        size: sizeLabel,
                        available: ((_k = edge.node) === null || _k === void 0 ? void 0 : _k.availableForSale) || false,
                        id: (_l = edge.node.id) === null || _l === void 0 ? void 0 : _l.split("/").pop(),
                        sku: ((_m = edge.node) === null || _m === void 0 ? void 0 : _m.sku) || undefined,
                        price: {
                            regular: isValidPrice(regular) ? regular : price.regular,
                            sale: isValidPrice(sale) ? sale : ((_o = price.sale) !== null && _o !== void 0 ? _o : undefined),
                        },
                    };
                });
                setSizeOptions(newSizeOptions);
                const { name: promoNameR, bgColor: bgColorR, fontColor: fontColorR } = extractPromoData(data === null || data === void 0 ? void 0 : data.product);
                setPromoMessage(promoNameR);
                if (bgColorR !== undefined)
                    setPromoBgColor(`#${bgColorR}`);
                if (fontColorR !== undefined)
                    setPromoFontColor(`#${fontColorR}`);
                return data;
            }
            else {
                console.error("Error fetching related variants data:", errors);
                return null;
            }
        }
        catch (error) {
            console.error(error);
            setLoadingSwatch(false);
        }
    });
    /**
     * Check if product is marked as "coming soon" via metafield or tags
     * Metafield: custom.coming_soon = "true" | custom.coming_soon_date | custom.notify_me
     * Tags: "coming-soon", "pre-order", "notify-me"
     */
    const isProductComingSoon = () => {
        // Check metafields
        if (metafields && Array.isArray(metafields)) {
            const comingSoonMetafield = metafields.find(mf => (mf.namespace === 'custom' || mf.namespace === 'global') &&
                (mf.key === 'coming_soon' || mf.key === 'notify_me' || mf.key === 'coming_soon_date'));
            if (comingSoonMetafield) {
                if (comingSoonMetafield.value === 'true' || comingSoonMetafield.value === '1') {
                    return true;
                }
                // Check future date
                if (comingSoonMetafield.key === 'coming_soon_date') {
                    try {
                        const futureDate = new Date(comingSoonMetafield.value);
                        if (futureDate > new Date())
                            return true;
                    }
                    catch (e) {
                        // Invalid date
                    }
                }
            }
        }
        // Check tags
        if (tags && Array.isArray(tags)) {
            const comingSoonTags = ['coming-soon', 'coming soon', 'comingsoon', 'pre-order', 'preorder', 'notify-me', 'notify me'];
            return tags.some(tag => comingSoonTags.includes(tag.toLowerCase()));
        }
        return false;
    };
    /**
     * Check if variant is coming soon (product coming soon + variant unavailable)
     */
    const isVariantComingSoon = (variantTitle) => {
        if (!isProductComingSoon())
            return false;
        const list = activeVariants.length > 0 ? activeVariants : variants;
        const variant = list === null || list === void 0 ? void 0 : list.find(v => v.title === variantTitle);
        return variant ? !variant.available : false;
    };
    const openBackInStockPopup = (option) => {
        if (!option.id)
            return;
        setBackInStockOption(option);
    };
    const isImageObj = (img) => typeof img === "object" && "url" in img;
    //Model image getting from Product.image (featuredImage)
    const modelImageUrl = isImageObj(image) ? image.url : (image || '');
    // From Birdsnest request. Fredhopper update "customAttributes?.media" to have the first item has a parsable string (JSON);
    // Add a condition to make Preact components work with both types of media (array or string)
    let mediaArray = (_b = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.media) !== null && _b !== void 0 ? _b : [];
    if (mediaArray.length > 0 && typeof mediaArray[0] === "string" && mediaArray[0].includes("[\"")) {
        try {
            const parsed = JSON.parse(mediaArray[0]);
            mediaArray = Array.isArray(parsed) ? parsed : [];
        }
        catch (_p) {
            mediaArray = [];
        }
    }
    const productOnlyImageUrl = mediaArray.find((url) => url.includes('Product_Front')) || '';
    const secondImage = mediaArray[1] || '';
    const imgAlt = isImageObj(image) ? image.alt : title;
    useEffect(() => {
        if (images.model) {
            //Render when click on variant
            if (isModelView) {
                setImgMainNormalized(images.model || '');
            }
            else {
                setImgMainNormalized((images === null || images === void 0 ? void 0 : images.imgProduct) || '');
            }
            setImgSecondNormalized((images === null || images === void 0 ? void 0 : images.imgSecond) || '');
        }
        else {
            //Initial render
            if (isModelView) {
                setImgMainNormalized(modelImageUrl || '');
            }
            else {
                setImgMainNormalized(productOnlyImageUrl || '');
            }
            setImgSecondNormalized(secondImage || '');
        }
    }, [isModelView, images]);
    const normalisedSizes = (() => {
        if (size && size.length > 0 && size.some((s) => s && s.trim() !== "")) {
            return size;
        }
        if (customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.sizes) {
            if (Array.isArray(customAttributes.sizes)) {
                return customAttributes.sizes;
            }
            return String(customAttributes.sizes)
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean);
        }
        if (customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.variant_title) {
            return [String(customAttributes.variant_title)];
        }
        return [];
    })();
    // If variant price was -1/invalid, use product price for display (never show $-1)
    const displayRegular = (priceRegular != null && priceRegular >= 0) ? priceRegular : price.regular;
    const displaySale = (priceSale != null && priceSale >= 0) ? priceSale : ((_c = price.sale) !== null && _c !== void 0 ? _c : undefined);
    const isSale = Boolean(displaySale != null && displaySale < displayRegular);
    const getElevarProductOverrides = () => {
        var _a;
        const selectedOption = (_a = sizeOptions.find((option) => option.id === selectedSize)) !== null && _a !== void 0 ? _a : sizeOptions[0];
        return {
            productId,
            variantId: selectedSize !== null && selectedSize !== void 0 ? selectedSize : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id,
            variantTitle: selectedSizeTitle !== null && selectedSizeTitle !== void 0 ? selectedSizeTitle : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.size,
            sku: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.sku,
            name: title,
            brand,
            price: isSale && displaySale != null ? displaySale : displayRegular,
            compareAtPrice: isSale ? displayRegular : undefined,
        };
    };
    const rawFlags = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.custom_flag;
    const allFlags = Array.isArray(rawFlags) ? rawFlags : rawFlags != null ? [rawFlags] : [];
    const flagPriority = [
        'Sale',
        'Coming Soon',
        'Just Landed',
        'Back In Stock',
        'Best Seller',
        'New',
        'Exclusive',
    ];
    const customFlags = allFlags
        .slice()
        .sort((a, b) => {
        const priorityOfA = flagPriority.findIndex((p) => p.toLowerCase() === a.toLowerCase());
        const priorityOfB = flagPriority.findIndex((p) => p.toLowerCase() === b.toLowerCase());
        return (priorityOfA === -1 ? flagPriority.length : priorityOfA) - (priorityOfB === -1 ? flagPriority.length : priorityOfB);
    })
        .slice(0, 2);
    const hasSaleFlag = customFlags.some((f) => f.toLowerCase() === 'sale');
    const hasComingSoonFlag = customFlags.some((f) => f.toLowerCase().includes('coming soon'));
    const isFinalSale = ((_d = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.isFinalSale) === null || _d === void 0 ? void 0 : _d[0]) || false;
    // const colors =
    //   customAttributes?.colors ||
    //   (customAttributes?.custom_colour_swatch_hex
    //     ? [
    //         {
    //           code: customAttributes.custom_colour_swatch_hex,
    //           name: customAttributes.custom_colour_name || product.color,
    //         },
    //       ]
    //     : []);
    // const colorCount =
    //   (customAttributes?.custom_colour_count &&
    //     Number(customAttributes.custom_colour_count)) ||
    //   colors.length;
    const normalisedRating = (ratingAverage !== undefined || ratingCount !== undefined)
        ? {
            average: Number(ratingAverage) || 0,
            count: Number(ratingCount) || 0,
        }
        : (rating || {
            average: Number((_e = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.yotpo_reviews_average) === null || _e === void 0 ? void 0 : _e[0]) ||
                Number((_f = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.reviews_group_rating) === null || _f === void 0 ? void 0 : _f[0]) ||
                0,
            count: Number((_g = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.yotpo_reviews_count) === null || _g === void 0 ? void 0 : _g[0]) ||
                Number((_h = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.reviews_rating_count) === null || _h === void 0 ? void 0 : _h[0]) ||
                Number((_j = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.reviews_group_rating_count) === null || _j === void 0 ? void 0 : _j[0]) ||
                0,
        });
    // const normalisedRatingHeart =
    //   (ratingAverageHeart !== undefined || ratingCountHeart !== undefined)
    //     ? {
    //         average: Number(ratingAverageHeart) || 0,
    //         count: Number(ratingCountHeart) || 0,
    //       }
    //     : (
    //       rating || {
    //         average: Number(customAttributes?.yotpo_reviews_average) || 0,
    //         count:
    //           Number(customAttributes?.yotpo_reviews_count) ||
    //           Number(customAttributes?.reviews_rating_count) ||
    //           0,
    //       }
    //     );
    const renderStars = () => {
        const activeStars = Math.max(0, Math.min(5, Math.round(normalisedRating.average)));
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(h("span", { key: i, class: i <= activeStars ? styles.starFilled : styles.starEmpty },
                h("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    h("path", { d: "M6.57932 0.360263L7.93276 3.10269C8.02688 3.29343 8.20886 3.4256 8.41937 3.45613L11.4459 3.89593C11.9761 3.97303 12.1876 4.62434 11.8041 4.99806L9.61412 7.13273C9.46193 7.28117 9.39234 7.49518 9.42838 7.70469L9.94528 10.719C10.0359 11.2469 9.4817 11.6494 9.00761 11.4003L6.30072 9.97729C6.11249 9.87841 5.88746 9.87841 5.69922 9.97729L2.99234 11.4003C2.51825 11.6496 1.96405 11.2469 2.05467 10.719L2.57156 7.70469C2.60761 7.49518 2.53802 7.28117 2.38583 7.13273L0.195843 4.99806C-0.187637 4.62409 0.0238775 3.97278 0.55404 3.89593L3.58057 3.45613C3.79109 3.4256 3.97306 3.29343 4.06718 3.10269L5.42062 0.360263C5.65742 -0.120088 6.34228 -0.120088 6.57932 0.360263Z", fill: Boolean(i <= activeStars) ? "#FFD800" : "#c6c6c6" }))));
        }
        return (h("div", { class: styles.rating },
            h("div", { class: styles.stars }, stars),
            (h("span", { class: styles.ratingCount },
                "(",
                normalisedRating.count,
                ")"))));
    };
    const renderHearts = (heartScore) => {
        // Convert heartScore (1-10) to hearts (0-5)
        // heartScore 3 = 3/2 = 1.5 hearts = 1 full + 1 half + 3 empty
        const normalizedScore = Math.max(0, Math.min(10, heartScore));
        const heartsValue = normalizedScore / 2;
        const fullHearts = Math.floor(heartsValue);
        const hasHalfHeart = heartsValue % 1 >= 0.5;
        // SVG path constants
        const filledPath = "M13.7884 1.29973C13.003 0.465879 11.9631 0.0101278 10.8533 0.0101278C9.74348 0.0101278 8.70044 0.469255 7.91499 1.30311L7.50477 1.73861L7.08819 1.29636C6.30274 0.462503 5.25652 0 4.14671 0C3.04008 0 1.99704 0.459127 1.21477 1.28961C0.429315 2.12346 -0.00316257 3.23077 1.74127e-05 4.40897C1.74127e-05 5.58717 0.435675 6.6911 1.22113 7.52496L7.19313 13.865C7.27581 13.9527 7.38711 14 7.49523 14C7.60335 14 7.71465 13.9561 7.79733 13.8683L13.7821 7.53846C14.5675 6.70461 15 5.5973 15 4.4191C15.0032 3.2409 14.5739 2.13359 13.7884 1.29973Z";
        const emptyPath = "M13.7884 1.29973C13.003 0.465879 11.9631 0.0101278 10.8533 0.0101278C9.74348 0.0101278 8.70044 0.469255 7.91499 1.30311L7.50477 1.73861L7.08819 1.29636C6.30274 0.462503 5.25652 0 4.14671 0C3.04008 0 1.99704 0.459127 1.21477 1.28961C0.429315 2.12346 -0.00316257 3.23077 1.74127e-05 4.40897C1.74127e-05 5.58717 0.435675 6.6911 1.22113 7.52496L7.19313 13.865C7.27581 13.9527 7.38711 14 7.49523 14C7.60335 14 7.71465 13.9561 7.79733 13.8683L13.7821 7.53846C14.5675 6.70461 15 5.5973 15 4.4191C15.0032 3.2409 14.5739 2.13359 13.7884 1.29973ZM13.1779 6.89366L7.49523 12.9028L1.82533 6.88353C1.20205 6.22185 0.858612 5.3441 0.858612 4.40897C0.858612 3.47384 1.19887 2.59609 1.82215 1.93779C2.44224 1.27948 3.26904 0.914878 4.14671 0.914878C5.02757 0.914878 5.85754 1.27948 6.48082 1.94116L7.19949 2.70412C7.36803 2.88305 7.63833 2.88305 7.80687 2.70412L8.51918 1.94791C9.14246 1.28623 9.97243 0.92163 10.8501 0.92163C11.7278 0.92163 12.5546 1.28623 13.1779 1.94454C13.8011 2.60622 14.1414 3.48396 14.1414 4.4191C14.1446 5.35423 13.8011 6.23198 13.1779 6.89366Z";
        const hearts = Array.from({ length: 5 }, (_, i) => {
            const index = i + 1;
            let heartType;
            if (index <= fullHearts) {
                heartType = 'filled';
            }
            else if (index === fullHearts + 1 && hasHalfHeart) {
                heartType = 'half';
            }
            else {
                heartType = 'empty';
            }
            let heartSvg;
            let className;
            switch (heartType) {
                case 'filled':
                    className = styles.starFilled;
                    heartSvg = (h("svg", { width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        h("path", { d: filledPath, fill: "#EE4747" })));
                    break;
                case 'half':
                    className = styles.starHalf;
                    const clipId = `clipHalfHeart_${index}`;
                    heartSvg = (h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "14", viewBox: "0 0 15 14", fill: "none" },
                        h("g", { clipPath: `url(#${clipId})` },
                            h("path", { d: "M13.8 1.3C13 0.5 12 0 10.9 0C9.8 0 8.7 0.5 8 1.3L7.6 1.7L7.2 1.3C6.3 0.5 5.3 0 4.1 0C2.9 0 2 0.5 1.2 1.3C0.4 2.1 0 3.2 0 4.4C0 5.6 0.4 6.7 1.2 7.5L7.2 13.8C7.2 13.8 7.4 13.9 7.5 13.9C7.6 13.9 7.7 13.9 7.8 13.8L13.8 7.5C14.6 6.7 15 5.6 15 4.4C15 3.2 14.6 2.1 13.8 1.3ZM7.5 12.9C7.6 12.9 7.7 2.8 7.8 2.7L8.5 1.9C9.1 1.2 10 0.9 10.8 0.9C11.6 0.9 12.5 1.3 13.1 1.9C13.7 2.6 14.1 3.4 14.1 4.4C14.1 5.3 13.8 6.2 13.1 6.9L7.4 12.9", fill: "#EE4747" })),
                        h("defs", null,
                            h("clipPath", { id: clipId },
                                h("rect", { width: "15", height: "14", fill: "white" })))));
                    break;
                case 'empty':
                    className = styles.starEmpty;
                    heartSvg = (h("svg", { width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        h("path", { d: emptyPath, fill: "#EE4747" })));
                    break;
            }
            return (h("span", { key: index, class: className }, heartSvg));
        });
        return (h("div", { class: styles.ratingHeart },
            h("div", { class: styles.hearts }, hearts),
            h("span", { class: styles.heartsCount }, `${heartScore * 10}% match`)));
    };
    const getSizeOptions = () => {
        const list = activeVariants.length > 0 ? activeVariants : (variants || []);
        if (list && list.length > 0) {
            return list.map(variant => {
                var _a;
                return ({
                    size: variant.title,
                    available: variant.available,
                    id: (_a = variant.id) === null || _a === void 0 ? void 0 : _a.split('/').pop(),
                    sku: variant.sku,
                    price: variant === null || variant === void 0 ? void 0 : variant.price
                });
            });
        }
        return [];
    };
    const renderSizes = () => {
        if (!sizeOptions || sizeOptions.length === 0)
            return null;
        return (h("div", { class: styles.sizeSelector }, sizeOptions.map((option, index) => {
            const isDisabled = !option.available;
            const normSize = (s) => (s || "").split("/")[0].trim().toLowerCase();
            const isSelected = selectedSizeTitle != null && normSize(selectedSizeTitle) === normSize(option.size);
            const isComingSoon = (hasComingSoonFlag || isVariantComingSoon(option.size)) && !option.available;
            return (h("span", { key: index, class: `${styles.sizeOption} ${isDisabled && !isComingSoon ? styles.sizeDisabled : ""} ${isSelected ? styles.sizeSelected : ""} ${isComingSoon ? styles.sizeComingSoon : ""}`, onClick: (e) => {
                    var _a, _b, _c;
                    e.preventDefault();
                    e.stopPropagation();
                    if (isComingSoon || isDisabled) {
                        openBackInStockPopup(option);
                    }
                    else {
                        // Clear any previous cart messages
                        setCartSuccess(false);
                        setCartError(null);
                        // If variant price is -1 or invalid, use product price
                        const isValidPrice = (n) => n != null && !Number.isNaN(n) && n >= 0;
                        const reg = (_a = option.price) === null || _a === void 0 ? void 0 : _a.regular;
                        const sale = (_b = option.price) === null || _b === void 0 ? void 0 : _b.sale;
                        setPriceRegular(isValidPrice(reg) ? reg : price.regular);
                        setPriceSale(isValidPrice(sale) ? sale : ((_c = price.sale) !== null && _c !== void 0 ? _c : undefined));
                        // Track by label; sync effect derives the variant ID from sizeOptions
                        if (!isSelected)
                            userHasInteractedWithSelectionRef.current = true;
                        setSelectedSizeTitle(isSelected ? null : option.size);
                    }
                }, title: isComingSoon || isDisabled ? 'Click to get notified when back in stock' : '' }, option.size));
        })));
    };
    const getRelatedColorProducts = () => {
        const relatedColors = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.swatch_info;
        if (!relatedColors || !Array.isArray(relatedColors))
            return [];
        // FH API has updated 'swatch_info' attribute to include 'active' colour swatch as the first item in the array.
        // Instead of removing the first item, we need to filter out duplicate colour swatches in case some 'swatch_info' attributes do not have this change yet.
        const seenProductIds = new Set();
        return relatedColors.filter((item) => {
            if (seenProductIds.has(item.product_id))
                return false;
            seenProductIds.add(item.product_id);
            return true;
        });
    };
    const relatedColorProducts = getRelatedColorProducts();
    const colorNameToHex = (colorName) => {
        const colorMap = {
            'black': '#000000',
            'white': '#FFFFFF',
            'red': '#FF0000',
            'blue': '#0000FF',
            'green': '#008000',
            'yellow': '#FFFF00',
            'orange': '#FFA500',
            'purple': '#800080',
            'pink': '#FFC0CB',
            'brown': '#8B4513',
            'grey': '#808080',
            'gray': '#808080',
            'navy': '#000080',
            'beige': '#F5F5DC',
            'cream': '#FFFDD0',
            'gold': '#FFD700',
            'silver': '#C0C0C0',
            'coral': '#FF7F50',
            'teal': '#008080',
            'forest': '#228B22',
            'burgundy': '#800020',
            'olive': '#808000',
            'tan': '#D2B48C',
            'maroon': '#800000',
            'khaki': '#C3B091',
            'mint': '#98FF98',
            'lavender': '#E6E6FA',
            'rose': '#FF007F',
            'ivory': '#FFFFF0',
            'charcoal': '#36454F',
        };
        const normalizedName = colorName.toLowerCase().trim();
        return colorMap[normalizedName] || '#CCCCCC';
    };
    const getColorSwatchStyle = (colorProduct) => {
        var _a, _b, _c;
        const fallback = '#CCCCCC';
        if ((_a = colorProduct.colour_image) === null || _a === void 0 ? void 0 : _a.trim()) {
            return {
                backgroundImage: `url(${colorProduct.colour_image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundColor: fallback,
            };
        }
        if ((_b = colorProduct.colour_hex) === null || _b === void 0 ? void 0 : _b.trim()) {
            return { backgroundColor: colorProduct.colour_hex };
        }
        if ((_c = colorProduct.colour_group) === null || _c === void 0 ? void 0 : _c.trim()) {
            const meta = getColorFromMetaobjectMap(colorProduct.colour_group);
            if (meta === null || meta === void 0 ? void 0 : meta.plp_filter_image) {
                return {
                    backgroundImage: `url(${meta.plp_filter_image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundColor: fallback,
                };
            }
            if (meta === null || meta === void 0 ? void 0 : meta.plp_hex) {
                return { backgroundColor: meta.plp_hex };
            }
        }
        return { backgroundColor: fallback };
    };
    const renderColors = () => {
        if (!relatedColorProducts || relatedColorProducts.length < 2)
            return null;
        const displayColors = relatedColorProducts.slice(0, 4);
        return (h("div", { class: styles.colorSection },
            h("div", { class: styles.colorSwatches }, displayColors.map((colorProduct, index) => {
                var _a;
                return (h("div", { key: colorProduct.product_id, class: styles.colorSwatchWrapper, onClick: (e) => __awaiter(this, void 0, void 0, function* () {
                        e.preventDefault();
                        e.stopPropagation();
                        // Don't reload if clicking the same color
                        if (selectedColorIndex === index)
                            return;
                        // Clear any previous cart messages
                        setCartSuccess(false);
                        setCartError(null);
                        setSelectedColorIndex(index);
                        // Clear size selection and interaction flag so switching color does not auto-add prematurely
                        userHasInteractedWithSelectionRef.current = false;
                        setSelectedSizeTitle(null);
                        setSelectedSize(null);
                        if (colorProduct.handle)
                            setHandle(colorProduct.handle);
                        if (colorProduct.product_id)
                            setProductId(colorProduct.product_id);
                        if (colorProduct.front_media)
                            setImgMainNormalized(colorProduct.front_media);
                        yield getRelatedVariantsData(colorProduct.product_id);
                    }) },
                    h("span", { class: `${styles.colorSwatch} ${selectedColorIndex === index ? styles.colorSwatchSelected : ""} ${((_a = colorProduct.colour_name) === null || _a === void 0 ? void 0 : _a.toLowerCase().trim()) === 'white' ? styles.colorSwatchWhite : ''}`, style: getColorSwatchStyle(colorProduct) }),
                    h("span", { class: styles.colorTooltip }, colorProduct.colour_name)));
            })),
            h("span", { class: styles.colorCount },
                relatedColorProducts.length,
                " colours")));
    };
    const styleBadge = (customFlag) => {
        switch (customFlag) {
            case "Sale":
                return styles.badgeSale;
            case "Coming Soon":
                return styles.badgeComingSoon;
            case "Just Landed":
                return styles.badgeJustLanded;
            case "Back In Stock":
                return styles.badgeBackInStock;
            case "Best Seller":
                return styles.badgeBestseller;
            case "New":
                return styles.badgeNew;
            case "Exclusive":
                return styles.badgeExclusive;
            default:
                return styles.badgeBestseller;
        }
    };
    const getSelectedVariant = () => {
        const list = activeVariants.length > 0 ? activeVariants : (variants || []);
        if (selectedSize && list.length > 0) {
            const matched = list.find((v) => { var _a; return ((_a = v.id) === null || _a === void 0 ? void 0 : _a.split('/').pop()) === String(selectedSize).split('/').pop(); });
            if (matched)
                return matched;
        }
        if (selectedSizeTitle && list.length > 0) {
            const norm = (s) => (s || '').split('/')[0].trim().toLowerCase();
            const matched = list.find((v) => norm(v.title) === norm(selectedSizeTitle));
            if (matched)
                return matched;
        }
        return product.selectedVariant || list[0] || null;
    };
    useEffect(() => {
        const numericId = toNumericId(productId);
        const variant = getSelectedVariant();
        const vid = selectedSize || (variant === null || variant === void 0 ? void 0 : variant.id) || "";
        if (vid) {
            setIsWishlisted(isVariantInWishlist(numericId, toNumericId(vid)));
        }
        else {
            setIsWishlisted(isProductInWishlist(numericId));
        }
    }, [productId, handle]);
    // Update wishlist state when variant (size) changes
    useEffect(() => {
        const variant = getSelectedVariant();
        const vid = selectedSize || (variant === null || variant === void 0 ? void 0 : variant.id) || "";
        if (vid) {
            setIsWishlisted(isVariantInWishlist(toNumericId(productId), toNumericId(vid)));
        }
    }, [selectedSize]);
    // When the user switches color swatches, `handle` changes to the new product's handle.
    // Swym's injected button is not managed by React so it holds a stale product URL.
    // Remove only this tile's button container, then call initializeCollections — Swym's
    // duplicate-check skips every other tile that already has a container, so in practice
    // only this tile gets a fresh button injected with the correct URL.
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (!((_a = window._swat) === null || _a === void 0 ? void 0 : _a.collectionsApi))
            return;
        (_c = (_b = productCardRef.current) === null || _b === void 0 ? void 0 : _b.querySelector('.swym-wishlist-collections-v2-container')) === null || _c === void 0 ? void 0 : _c.remove();
        window._swat.collectionsApi.initializeCollections(window._swat, true, (_e = (_d = window.Shopify) === null || _d === void 0 ? void 0 : _d.theme) === null || _e === void 0 ? void 0 : _e.schema_name);
    }, [handle]);
    // Listen for centralised wishlist-updated event (fired once when Swym data syncs).
    // Also listen for Swym's own DOM events so the heart updates instantly after
    // local add/remove without waiting for the next full sync.
    useEffect(() => {
        const recheckState = () => {
            setIsWishlisted(isProductInWishlist(toNumericId(productId)));
        };
        window.addEventListener(WISHLIST_UPDATED_EVENT, recheckState);
        return () => {
            window.removeEventListener(WISHLIST_UPDATED_EVENT, recheckState);
        };
    }, [productId]);
    const readCurrentInstoreMode = () => { var _a; return (_a = syncInstoreModeFromUrl()) !== null && _a !== void 0 ? _a : getInstoreModeFromStorage(); };
    /**
     * Opens fitting-room popup from current card selection (context must be provided).
     */
    const openFittingRoomPopupWithSelection = () => {
        var _a;
        if (!openFittingRoomPopup)
            return;
        const instoreMode = readCurrentInstoreMode();
        const variant = getSelectedVariant();
        const swatch = relatedColorProducts.length > 0 && selectedColorIndex != null
            ? relatedColorProducts[selectedColorIndex]
            : undefined;
        const swatchColourName = swatch === null || swatch === void 0 ? void 0 : swatch.colour_name;
        const fittingRoomColorLabel = ((swatchColourName === null || swatchColourName === void 0 ? void 0 : swatchColourName.trim()) || ((_a = product.color) === null || _a === void 0 ? void 0 : _a.trim()) || '').trim() ||
            undefined;
        let activeTitle = title || product.title;
        if (swatchColourName && product.color && swatchColourName.toLowerCase() !== product.color.toLowerCase()) {
            const oldColorRegex = new RegExp(`(\\s*[-–—]\\s*)${product.color}\\s*$`, 'i');
            if (oldColorRegex.test(activeTitle)) {
                activeTitle = activeTitle.replace(oldColorRegex, `$1${swatchColourName}`);
            }
        }
        const activeProduct = Object.assign(Object.assign({}, product), { id: productId || (swatch === null || swatch === void 0 ? void 0 : swatch.product_id) || product.id, title: activeTitle, handle: handle || (swatch === null || swatch === void 0 ? void 0 : swatch.handle) || product.handle, color: fittingRoomColorLabel || product.color, variants: activeVariants.length > 0 ? activeVariants : product.variants });
        openFittingRoomPopup({
            product: activeProduct,
            variant,
            heroImageUrl: imgMain || (swatch === null || swatch === void 0 ? void 0 : swatch.front_media) || undefined,
            heroImageAlt: imgAlt,
            colorLabel: fittingRoomColorLabel,
            displayPriceRegular: displayRegular,
            displayPriceSale: displaySale,
            isInstoreMode: instoreMode,
        });
    };
    // TODO: build a full custom Wishlist component — currently triggers the Swym wishlist popup from Wishlist Plus Shopify App so the user
    // can select a variant themselves. The downside of this workaround
    // is that the wishlist button will break when indow.SwymCollectionsConfig.CollectionsSelectors gets changed.
    const handleWishlistClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!window._swat) {
            return;
        }
        const selectedVariant = getSelectedVariant();
        const swymProduct = convertToSwymProduct(productId, handle, selectedSize || (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) || defaultVariantIdRef.current || "");
        if (!swymProduct)
            return;
        if (checkIfWishlisted(swymProduct) || isProductInWishlist(toNumericId(productId))) {
            removeFromWishlist(window._swat, swymProduct);
            setIsWishlisted(false);
        }
        else {
            addToWishlist(window._swat, swymProduct);
            setIsWishlisted(true);
        }
    };
    const handleAddToCart = (e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        e.stopPropagation();
        // Reset previous states
        setCartError(null);
        setCartSuccess(false);
        // Get related color products to check if color selection is required
        const relatedColorProducts = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.swatch_info;
        const hasMultipleColors = relatedColorProducts && relatedColorProducts.length > 1;
        // Validate color selection
        if (hasMultipleColors && selectedColorIndex === null) {
            setCartError('Please select a color');
            return;
        }
        // Validate size selection
        if (!selectedSize) {
            setCartError('Please select a size');
            return;
        }
        // Start adding to cart
        setAddingToCart(true);
        try {
            if (readCurrentInstoreMode() != null) {
                openFittingRoomPopupWithSelection();
                setSelectedSizeTitle(null);
                setSelectedSize(null);
                setCartSuccess(false);
            }
            else {
                yield addToCart(selectedSize, 1);
                if (trackingListId) {
                    trackAddToCart(product, trackingListId, 1, { variantId: selectedSize || undefined });
                }
                setSelectedSizeTitle(null);
                setSelectedSize(null);
                setCartSuccess(false);
            }
        }
        catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Failed to add to cart';
            setCartError(errorMessage);
        }
        finally {
            setAddingToCart(false);
        }
    });
    // Sync selectedSize (variant ID) from selectedSizeTitle (label) whenever sizes or title changes.
    // This is the single source of truth for keeping the ID in sync across color switches.
    useEffect(() => {
        if (!selectedSizeTitle || sizeOptions.length === 0) {
            if (!selectedSizeTitle)
                setSelectedSize(null);
            return;
        }
        const normSize = (s) => (s || "").split("/")[0].trim().toLowerCase();
        const match = sizeOptions.find((o) => normSize(o.size) === normSize(selectedSizeTitle));
        // Only select if the matched variant is actually in stock
        setSelectedSize((match === null || match === void 0 ? void 0 : match.available) && (match === null || match === void 0 ? void 0 : match.id) ? match.id : null);
    }, [sizeOptions, selectedSizeTitle]);
    // Auto add to cart when both size and color are selected
    useEffect(() => {
        const autoAddToCart = () => __awaiter(this, void 0, void 0, function* () {
            // Get related color products to check if color selection is required
            const relatedColorProducts = customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.swatch_info;
            const hasMultipleColors = relatedColorProducts && relatedColorProducts.length > 1;
            // Check if both required selections are made
            const colorSelected = !hasMultipleColors || selectedColorIndex !== null;
            const sizeSelected = selectedSize !== null;
            // Only auto-add after user has clicked a size or color (not on initial single-size auto-select)
            if (!userHasInteractedWithSelectionRef.current)
                return;
            // Only proceed if both are selected and not already adding
            if (colorSelected && sizeSelected && !addingToCart && !cartSuccess) {
                setAddingToCart(true);
                try {
                    if (readCurrentInstoreMode() != null) {
                        openFittingRoomPopupWithSelection();
                        setCartSuccess(true);
                    }
                    else {
                        yield addToCart(selectedSize, 1);
                        if (trackingListId) {
                            trackAddToCart(product, trackingListId, 1, { variantId: selectedSize || undefined });
                        }
                        setCartSuccess(true);
                    }
                    // Wait 500ms so user can see both selections highlighted
                    yield new Promise(resolve => setTimeout(resolve, 500));
                    // Clear selections for next add
                    userHasInteractedWithSelectionRef.current = false;
                    setSelectedSizeTitle(null); // sync effect will clear selectedSize
                    setSelectedSize(null); // explicit clear for immediate safety
                    setCartSuccess(false);
                }
                catch (error) {
                    const errorMessage = error instanceof Error ? error.message : 'Failed to add to cart';
                    setCartError(errorMessage);
                    // Wait 500ms so user can see what they selected
                    yield new Promise(resolve => setTimeout(resolve, 500));
                    // IMPORTANT: Deselect even on error to prevent infinite loop
                    userHasInteractedWithSelectionRef.current = false;
                    setSelectedSizeTitle(null);
                    setSelectedSize(null);
                    setCartSuccess(false);
                }
                finally {
                    setAddingToCart(false);
                }
            }
        });
        autoAddToCart();
    }, [selectedSize, selectedColorIndex, customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.swatch_info]);
    useEffect(() => {
        var _a, _b, _c;
        if ((product === null || product === void 0 ? void 0 : product.variants) && ((_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setActiveVariants(product.variants);
            const options = getSizeOptions();
            setSizeOptions(options);
            // Don't auto-select on initial load — auto-selection only happens after a color click
            // (see getRelatedVariantsData) to avoid auto-adding to cart without user interaction.
        }
        if (product === null || product === void 0 ? void 0 : product.handle) {
            setHandle(product.handle);
        }
        if (product === null || product === void 0 ? void 0 : product.media) {
            if (((_b = product.media[0]) === null || _b === void 0 ? void 0 : _b.mediaContentType) === 'VIDEO') {
                setVideoMain(product.media[0].url);
            }
            else {
                setVideoMain("");
                setImages({ model: product.media[0].url, imgProduct: ((_c = product === null || product === void 0 ? void 0 : product.media) === null || _c === void 0 ? void 0 : _c.length) > 1 ? product.media[1].url : "" });
            }
        }
    }, [product]);
    // customAttributes?.related_colour_products?.map(async (product: RelatedColorProduct, index: number) => {
    //     await getRelatedVariantsData(product.handle);
    // });
    return (h("div", { ref: productCardRef, class: layout === 'gridThree'
            ? styles.productCardThree
            : layout === "gridTwo" || layout === "gridFour"
                ? `${styles.productCard} ${smallCard ? styles.productCardSmall : ""}`
                : styles.productCardList },
        loadingSwatch ? h("div", { class: styles.loadingOverlay },
            h(LoadingSkeleton, null)) : "",
        h("div", { class: `${styles.productLink} product-grid-item` },
            h("a", { class: `${styles.productImage} birdsnest-product-card-image ${loadingSwatch ? styles.productLinkLoading : ""}`, href: `/products/${handle}`, title: title, onClick: () => {
                    if (trackingListId) {
                        trackSelectItem(product, trackingListId, trackingPosition, getElevarProductOverrides());
                    }
                } },
                h("div", { class: `${styles.badges} birdsnest-product-card-badges` }, customFlags.map((flag, i) => (h("span", { key: i, class: styleBadge(flag) }, flag)))),
                seeInOutfit && (h("div", { class: styles.badgesSeeInOutfit },
                    h("span", { class: `${styles.badgesSeeInOutfitLabel} ${customFlags.length === 0 ? styles.badgesSeeInOutfitLabelTop : ""}` }, "See in outfit"),
                    h("a", { href: seeInOutfit.url, title: "See in outfit" },
                        h("img", { src: seeInOutfit.image, alt: imgAlt, loading: "lazy" })))),
                videoMain ? (h("video", { src: videoMain, loop: true, autoPlay: true, muted: true, playsInline: true, controls: false })) : (imgMain && (h("div", { class: styles.productImageWrapper, onMouseEnter: () => setHasHovered(true) },
                    h("img", { src: imgMain, alt: imgAlt, loading: "lazy" }),
                    hasHovered && imgSecond && (h("img", { src: imgSecond, alt: imgAlt, loading: "lazy" }))))),
                isFinalSale && (h("div", { class: styles.finalSaleBanner }, "Final Sale (No Returns)")),
                isQuickViewEnabled && (h("a", { class: `${styles.productQuickViewBtn} quickview-button-card`, href: `/products/${handle}`, "data-handle": handle, "data-button-quick-view": true },
                    h("quick-view-button", null),
                    h("svg", { width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        h("path", { d: "M12.8075 12.7811H2.14512C2.01523 12.7805 1.89002 12.7328 1.79287 12.6468C1.69573 12.5609 1.63331 12.4426 1.61727 12.3141L0.680354 3.89382C0.672021 3.82046 0.679266 3.74616 0.701617 3.67577C0.723968 3.60538 0.760924 3.54047 0.810085 3.48525C0.859246 3.43003 0.919511 3.38574 0.986963 3.35527C1.05442 3.32479 1.12754 3.3088 1.2016 3.30835H13.751C13.8251 3.30882 13.8982 3.32481 13.9657 3.35529C14.0331 3.38577 14.0934 3.43006 14.1425 3.48528C14.1917 3.54049 14.2286 3.6054 14.251 3.67579C14.2734 3.74617 14.2806 3.82046 14.2723 3.89382L13.3354 12.3141C13.3193 12.4426 13.2569 12.5609 13.1598 12.6468C13.0626 12.7328 12.9374 12.7805 12.8075 12.7811Z", stroke: "white", "stroke-width": "1.35417", "stroke-linecap": "round", "stroke-linejoin": "round" }),
                        h("path", { d: "M4.83667 5.4134V3.30834C4.83667 2.61046 5.11473 1.94117 5.60968 1.4477C6.10463 0.954231 6.77592 0.677002 7.47588 0.677002C8.17584 0.677002 8.84714 0.954231 9.34209 1.4477C9.83703 1.94117 10.1151 2.61046 10.1151 3.30834V5.4134", stroke: "white", "stroke-width": "1.35417", "stroke-linecap": "round", "stroke-linejoin": "round" })),
                    h("span", { class: "product-upsell__btn-progress" },
                        h("svg", { height: "18", width: "18", class: "svg-loader" },
                            h("circle", { r: "7", cx: "9", cy: "9" }),
                            h("circle", { "stroke-dasharray": "87.96459430051421 87.96459430051421", r: "7", cx: "9", cy: "9" }))),
                    "Quick view")),
                promoMessage && (h("span", { class: styles.promoBadge, style: Object.assign(Object.assign({}, (promoBgColor ? { background: promoBgColor } : {})), (promoFontColor ? { color: promoFontColor } : {})) }, promoMessage))),
            isPreloved && (h("a", { href: `/products/${handle}`, title: "Preloved", class: styles.prelovedBadge }, "Preloved")),
            h("div", { class: styles.productInfo },
                h("div", { class: `birdsnest-product-card-brand ${styles.brandContainer} ${loadingSwatch ? styles.productLinkLoading : ""}` },
                    brand && h("div", { class: `${styles.brand} ${smallCard ? styles.brandSmall : ""}` }, brand),
                    normalisedRating.count > 0 && renderStars()),
                h("a", { class: `product-grid-item__title ${loadingSwatch ? styles.productLinkLoading : ""}`, href: `/products/${handle}`, title: title, onClick: () => {
                        if (trackingListId) {
                            trackSelectItem(product, trackingListId, trackingPosition, getElevarProductOverrides());
                        }
                    } },
                    h("h3", { class: `${styles.productTitle} ${smallCard ? styles.productTitleSmall : ""}` }, title)),
                h("div", { class: `${styles.productPrice} ${loadingSwatch ? styles.productLinkLoading : ""}` },
                    isSale && h("span", { class: styles.originalPrice },
                        "$",
                        displayRegular.toFixed(2)),
                    h("span", { class: isSale ? styles.salePrice : styles.regularPrice }, isSale && displaySale != null
                        ? `$${displaySale.toFixed(2)}`
                        : displayRegular
                            ? `$${displayRegular.toFixed(2)}`
                            : (!isHeaderSearch || brand !== 'Birdsnest Live') && 'Free')),
                h("div", { class: `birdsnest-product-card-actions ${styles.productActions}` },
                    h("div", { class: loadingSwatch ? styles.productLinkLoading : "" }, renderSizes()),
                    renderColors()),
                ((_l = (_k = window.liquidCustom) === null || _k === void 0 ? void 0 : _k.styleMatches) === null || _l === void 0 ? void 0 : _l.length) > 0 && (h("div", { class: `birdsnest-product-card-hearts ${styles.heartsContainer}` }, renderHearts((customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.heart_score) || 0))))),
        h(BackInStockPopup, { open: backInStockOption != null, onClose: () => setBackInStockOption(null), productTitle: title, variantLabel: (_m = backInStockOption === null || backInStockOption === void 0 ? void 0 : backInStockOption.size) !== null && _m !== void 0 ? _m : '', shopifyVariantId: (_o = backInStockOption === null || backInStockOption === void 0 ? void 0 : backInStockOption.id) !== null && _o !== void 0 ? _o : '' })));
}
